/* 問題jsonファイルの設定 */

import Covid19Back from '../static/covid19-goback/content.json'
import Covid19Out from '../static/covid19-goout/content.json'
import Default from '../static/default/content.json'
import DefaultIntermediate from '../static/default-intermediate/content.json'
import Pet from '../static/pet/content.json'
import PetEn from '../static/pet-en/content.json'
import PetSn from '../static/pet-sn/content.json'
import PetTg from '../static/pet-tg/content.json'
import PetPt from '../static/pet-pt/content.json'
import Welfare from '../static/welfare/content.json'
import WelfareIntermediate from '../static/welfare-intermediate/content.json'

import DefaultEn from '../static/default-en/content.json'
import DefaultIntermediateEn from '../static/default-intermediate-en/content.json'

import DefaultCn from '../static/default-cn/content.json'
import DefaultIntermediateCn from '../static/default-intermediate-cn/content.json'

import DefaultPt from '../static/default-pt/content.json'
import DefaultIntermediatePt from '../static/default-intermediate-pt/content.json'

import DefaultSn from '../static/default-sn/content.json'
import DefaultIntermediateSn from '../static/default-intermediate-sn/content.json'

import DefaultTg from '../static/default-tg/content.json'

export default {
    data: function() {
        return {
            "questions": {
                "covid19-goback": Covid19Back,
                "covid19-goout": Covid19Out,
                "default": Default,
                "default-intermediate": DefaultIntermediate,
                "pet": Pet,
                "pet-en": PetEn,
                "pet-sn": PetSn,
                "pet-tg": PetTg,
                "pet-pt": PetPt,
                "welfare": Welfare,
                "welfare-intermediate": WelfareIntermediate,
                "default-en": DefaultEn,
                "default-intermediate-en": DefaultIntermediateEn,
                "default-cn": DefaultCn,
                "default-intermediate-cn": DefaultIntermediateCn,
                "default-pt": DefaultPt,
                "default-intermediate-pt": DefaultIntermediatePt,
                "default-sn": DefaultSn,
                "default-intermediate-sn": DefaultIntermediateSn,
                "default-tg": DefaultTg,
            }
        }
    },
    // jsonへのアクセサ
    // TODO: ここにjsonビルドメソッド全部持ってきたほうがよさそう
    methods: {
        getFolderPath: function(level){ return '/static/' + level + '/'},
        getImageFolderPath: function(level){ return '/static/' + level + '/img/'},
        getKaoImageFolderPath: function(){ return '/static/common/'},
        getLinkFolderPath: function(level){ return '/static/' + level + '/links/'},
        getCategories: function(level){ return this.questions[level].categories; },
        getTotalLength: function(level){
            const len = this.getCategories(level).map((category) => category.q.length);
            console.log("categoryLength", len);
            return len.reduce((acc, v)=> acc + v);
        },
        getOptions: function(level){ return this.questions[level].options },
        getQText: function(level, index){ 
            let k = 0;
            for(let category of this.getCategories(level)) {
                for(let q of category.q) {
                    if(k++==index)
                        return q.text;
                }
            }
            return '';
        },
        calScore: function(level, answers) {
            let total = 0;
            let k = 0;
            this.questions[level].categories.forEach((category, i) => {
                category.q.forEach((q, j) => {
                    if(answers.length <= k) {
                        console.error("クエリパラメータが間違っています");
                        return total;
                    }
                    const index = answers[k++];
                    total += q.score_list[index];
                });
            });
            return total;
        },
        calcScores: function(level, answers) {
            let k = 0;
            return this.questions[level].categories.map((category, i) => {
                let total = 0;
                category.q.forEach((q, j) => {
                    const index = answers[k++];
                    total += q.score_list[index];
                });
                return total;
            });
        },
        calcMaxScores: function(level) {
            return this.questions[level].categories.map((category, i) => {
                let total = 0;
                category.q.forEach((q, j) => {
                    total += q.max
                });
                return total;
            });
        },
        getSummary: function(level, score) {
            const summary = this.questions[level].summary;
            // 一致する点数のコメントを返す
            for(var key in summary) {
                // 0-99形式から[0, 99]のrange形式に変換
                const range = key.split("-").map((v) => parseInt(v));
                if(range[0] <= score && score <= range[1]) return summary[key];
            }
            return null;
        },
        /* カテゴリーカード用のデータを作る */
        buildCategoryCard: function(level, answers) {
            let k = 0;
            const link = this.questions[level].link;
            const options = this.questions[level].options;
            const categories = this.getCategories(level);
            /* TODO: covid19のとき、赤に変えたほうがよい */
            const classes = ['good', 'poor', 'bad'];
            return categories.map((category, i) => {
                return {
                    title: '#' + (i + 1) + '. ' + category.text,
                    q: category.q.map((q, j) => {
                        /* はい、少し、いいえ のうちからせんたくされたもの */
                        const selected = answers[k++];
                        return {
                            key: 'collapse-' + i + '-' + j,
                            text: 'Q' + k + '. ' + q.text,
                            ans: options[selected],
                            ansIndex: k-1,
                            comment: q.comments? q.comments[selected == 0? 0: 1]: null,
                            link: link? ('/links/' + level + '/' + k): '',
                            headerClass: classes[selected],
                        }
                    }),
                };
            });
        },
        /* ContentPage用のデータを作成する */
        buildContent: function(level, page) {
            let k = 0;
            const categories = this.getCategories(level);
            return categories.map((category, i) => {
                return {
                    title: '#' + (i + 1) + '. ' + category.text,
                    options: this.questions[level].options,
                    q: category.q.map((q, j) => {
                        return {
                            ansIndex: k, /* 回答番号をつける */
                            text: 'Q' + ++k + '. ' + q.text,
                            img: this.getImageFolderPath(level) + 'Q' + k + '.png'
                        }
                    }),
                };
            })[page];
        },
        /* Confirm用のデータを作成する */
        buildConfirm: function(level) {
            let k = 0;
            const options = this.questions[level].options;
            const categories = this.getCategories(level);
            return categories.map((category, i) => {
                return {
                    title: '#' + (i + 1) + '. ' + category.text,
                    options: options,
                    q: category.q.map((q, j) => {
                        return {
                            key: 'options-' + i + '-' + j,
                            text: 'Q' + (k+1) + '. ' + q.text,
                            ansIndex: k++,
                        }
                    }),
                };
            });
        }
    }
}
